// 헤더 검색 모달
  (function () {
    const state = new WeakMap();

    function getBox(form) {
      let box = form.querySelector('#b7-search-results');

      if (box) return box;

      box = document.createElement('div');
      box.id = 'b7-search-results';
      box.className = 'b7-search-results';

      box.innerHTML = `
        <div class="b7-search-results__title">Products</div>
        <div class="b7-search-results__products"></div>

        <div class="b7-search-results__footer">
          <a class="b7-search-results__button" href="#">
            View All Results For "<span></span>"
          </a>
        </div>
      `;

      box.style.display = 'none';

      const target = form.querySelector('.search__inner') || form.querySelector('form') || form;
      target.appendChild(box);

      return box;
    }

    function setSearchState(form, stateClass) {
      form.classList.remove(
        'is-search-empty-query',
        'is-search-has-results',
        'is-search-no-results'
      );

      form.classList.add(stateClass);
    }

    function clearResults(form, box) {
      const productsBox = box.querySelector('.b7-search-results__products');

      box.style.display = 'block';
      setSearchState(form, 'is-search-empty-query');
      productsBox.innerHTML = '';
    }

    function renderEmpty(form, box, query) {
      const productsBox = box.querySelector('.b7-search-results__products');
      const button = box.querySelector('.b7-search-results__button');

      setSearchState(form, 'is-search-no-results');
      productsBox.innerHTML = `
    <div class="b7-search-results__empty">
      <strong>No results found for "${query}"</strong>
      <p>Check the spelling or use a different word or phrase.</p>
    </div>
  `;

      button.href = '/collections/all';
      button.textContent = 'View Every Products';
    }

    function renderResults(form, box, cards, query) {
      const productsBox = box.querySelector('.b7-search-results__products');
      const button = box.querySelector('.b7-search-results__button');

      setSearchState(form, 'is-search-has-results');

      productsBox.innerHTML = cards.map(card => `
        <div class="b7-search-result-product">
          ${card.outerHTML}
        </div>
      `).join('');

      button.href = `/search?q=${encodeURIComponent(query)}&type=product`;
      button.innerHTML = `View All Results For "<span>${query}</span>"`;
    }

    function runSearch(form, input) {
      const query = input.value.trim();
      const box = getBox(form);
      const productsBox = box.querySelector('.b7-search-results__products');
      const button = box.querySelector('.b7-search-results__button');
      const current = state.get(form) || {};

      clearTimeout(current.timer);

      if (current.controller) {
        current.controller.abort();
      }

      if (!query) {
        clearResults(form, box);

        state.set(form, {
          query: '',
          controller: null,
          timer: null
        });

        return;
      }

      box.style.display = 'block';
      setSearchState(form, 'is-search-has-results');

      productsBox.innerHTML = '<p class="b7-search-results__loading">Searching...</p>';
      button.href = `/search?q=${encodeURIComponent(query)}&type=product`;
      button.innerHTML = `View All Results For "<span>${query}</span>"`;

      const controller = new AbortController();

      const timer = setTimeout(async function () {
        try {
          const response = await fetch(
            `/search?q=${encodeURIComponent(query)}&type=product&options%5Bprefix%5D=last`,
            {
              signal: controller.signal
            }
          );

          const html = await response.text();

          if (input.value.trim() !== query) return;

          const doc = new DOMParser().parseFromString(html, 'text/html');

          const cards = Array.from(
            doc.querySelectorAll('#ProductGridContainer #items-grid .grid-item')
          )
            .filter(el => el.querySelector('a[href*="/products/"]'))
            .slice(0, 6);

          if (!cards.length) {
            renderEmpty(form, box, query);
            return;
          }

          renderResults(form, box, cards, query);
        } catch (error) {
          if (error.name === 'AbortError') return;
          console.error(error);
        }
      }, 180);

      state.set(form, {
        query,
        controller,
        timer
      });
    }
    
    document.addEventListener('input', function (e) {
    if (e.target.closest('.search-page-live-panel, .theme-template-search')) return;

    const input = e.target.closest('#search-in-modal, input[name="q"]');
    if (!input) return;

    const form = input.closest('#FormSearch');
    if (!form) return;

    runSearch(form, input);
  });
  })();


// 검색결과페이지 모달
  (function () {
    let timer = null;
    let controller = null;
    let latestQuery = '';

    const root = document.querySelector('.theme-template-search') || document.body;
    const overlay = document.querySelector('.search-page-overlay');

    function getPageInput() {
      return document.querySelector('.search-page-input');
    }

    function getPanelInput() {
      return document.querySelector('.search-page-live-input__field');
    }

    function getPanel() {
      return document.querySelector('.search-page-live-panel');
    }

    function getBody(panel) {
      return panel.querySelector('.search-page-live-body') || panel.querySelector('.search-page-live-panel__inner') || panel;
    }

    function getBox(panel) {
      let box = panel.querySelector('#b7-search-results');

      if (box) return box;

      box = document.createElement('div');
      box.id = 'b7-search-results';
      box.className = 'b7-search-results';

      box.innerHTML = `
        <div class="b7-search-results__title">Products</div>
        <div class="b7-search-results__products"></div>

        <div class="b7-search-results__footer">
          <a class="b7-search-results__button" href="#">
            View All Results For "<span></span>"
          </a>
        </div>
      `;

      box.style.display = 'none';

      getBody(panel).appendChild(box);

      return box;
    }

    function getQuery() {
      const panelInput = getPanelInput();
      const pageInput = getPageInput();

      if (panelInput && document.activeElement === panelInput) {
        return panelInput.value.trim();
      }

      return pageInput ? pageInput.value.trim() : '';
    }

    function syncInputs(value) {
      const pageInput = getPageInput();
      const panelInput = getPanelInput();

      if (pageInput && pageInput.value !== value) pageInput.value = value;
      if (panelInput && panelInput.value !== value) panelInput.value = value;
    }

    function setSearchState(panel, stateClass) {
      panel.classList.remove(
        'is-search-empty-query',
        'is-search-has-results',
        'is-search-no-results'
      );

      panel.classList.add(stateClass);
    }

    function openModal() {
      const panel = getPanel();
      const pageInput = getPageInput();
      const panelInput = getPanelInput();

      if (!panel || !overlay || !root) return;

      panel.hidden = false;
      overlay.classList.add('is-active');
      root.classList.add('search-active');
      document.documentElement.classList.add('search-open');

      if (pageInput && panelInput) {
        panelInput.value = pageInput.value;
      }

      if (window.matchMedia('(max-width: 1023px)').matches && panelInput) {
        setTimeout(function () {
          panelInput.focus();
        }, 0);
      }
    }

    function closeModal() {
      const panel = getPanel();

      if (!panel || !overlay || !root) return;

      panel.hidden = true;
      overlay.classList.remove('is-active');
      root.classList.remove('search-active');
      document.documentElement.classList.remove('search-open');
    }

    function setPosition() {
      const input = getPageInput();
      const panel = getPanel();

      if (!input || !panel) return;

      if (window.matchMedia('(max-width: 1023px)').matches) {
        panel.style.top = '';
        document.documentElement.style.removeProperty('--search-page-panel-top');
        return;
      }

      const rect = input.getBoundingClientRect();
      const top = rect.bottom + 8;

      panel.style.top = top + 'px';
      document.documentElement.style.setProperty('--search-page-panel-top', top + 'px');
    }

    function showMarketing(panel, box) {
      const productsBox = box.querySelector('.b7-search-results__products');

      box.style.display = 'none';
      setSearchState(panel, 'is-search-empty-query');

      if (productsBox) {
        productsBox.innerHTML = '';
      }
    }

    function showLoading(panel, box, query) {
      const productsBox = box.querySelector('.b7-search-results__products');
      const button = box.querySelector('.b7-search-results__button');

      box.style.display = 'block';
      setSearchState(panel, 'is-search-has-results');

      productsBox.innerHTML = '<p class="b7-search-results__loading">Searching...</p>';
      button.href = `/search?q=${encodeURIComponent(query)}&type=product`;
      button.innerHTML = `View All Results For "<span>${query}</span>"`;
    }

    function showEmpty(panel, box, query) {
      const productsBox = box.querySelector('.b7-search-results__products');
      const button = box.querySelector('.b7-search-results__button');

      box.style.display = 'block';
      setSearchState(panel, 'is-search-no-results');

      productsBox.innerHTML = `
        <div class="b7-search-results__empty">
          <strong>No results found for "${query}"</strong>
          <p>Check the spelling or use a different word or phrase.</p>
        </div>
      `;

      button.href = '/collections/all';
      button.textContent = 'View Every Products';
    }

    function showResults(panel, box, cards, query) {
      const productsBox = box.querySelector('.b7-search-results__products');
      const button = box.querySelector('.b7-search-results__button');

      box.style.display = 'block';
      setSearchState(panel, 'is-search-has-results');

      productsBox.innerHTML = cards.map(function (card) {
        return `
          <div class="b7-search-result-product">
            ${card.outerHTML}
          </div>
        `;
      }).join('');

      button.href = `/search?q=${encodeURIComponent(query)}&type=product`;
      button.innerHTML = `View All Results For "<span>${query}</span>"`;
    }

    function runSearch() {
      const panel = getPanel();

      if (!panel) return;

      const query = getQuery();
      const box = getBox(panel);

      clearTimeout(timer);

      if (controller) {
        controller.abort();
      }

      if (!query) {
        latestQuery = '';
        showMarketing(panel, box);
        return;
      }

      showLoading(panel, box, query);

      controller = new AbortController();
      latestQuery = query;

      timer = setTimeout(function () {
        fetch(
          `/search?q=${encodeURIComponent(query)}&type=product&options%5Bprefix%5D=last`,
          {
            signal: controller.signal
          }
        )
          .then(function (res) {
            return res.text();
          })
          .then(function (html) {
            if (latestQuery !== query) return;

            const doc = new DOMParser().parseFromString(html, 'text/html');

            const cards = Array.from(
              doc.querySelectorAll('#ProductGridContainer #items-grid .grid-item')
            )
              .filter(function (el) {
                return el.querySelector('a[href*="/products/"]');
              })
              .slice(0, 6);

            if (!cards.length) {
              showEmpty(panel, box, query);
              return;
            }

            showResults(panel, box, cards, query);
          })
          .catch(function (error) {
            if (error.name === 'AbortError') return;
            console.error(error);
          });
      }, 200);
    }

    document.addEventListener('focusin', function (e) {
      if (!e.target.matches('.search-page-input')) return;

      openModal();
      setPosition();
      runSearch();
    });

    document.addEventListener('input', function (e) {
      if (!e.target.matches('.search-page-input, .search-page-live-input__field')) return;

      syncInputs(e.target.value);

      openModal();
      setPosition();
      runSearch();
    });

    document.addEventListener('click', function (e) {
      if (!e.target.closest('.search-page-live-input__close')) return;

      closeModal();
    });

    if (overlay) {
      overlay.addEventListener('click', closeModal);
    }

    window.addEventListener('resize', function () {
      const panel = getPanel();

      if (!panel || panel.hidden) return;

      setPosition();
    });
  })();


